module.exports = __webpack_public_path__ + "honor-02.jpg?d96e0609466a940b16cce79d75ec3394";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/honor-02.jpg
// module id = 180
// module chunks = 0